/* JOURNAL */
export const GET_JOURNAL_DAYS = "GET_JOURNAL_DAYS"
export const GET_JOURNAL_DAYS_SUCCESS = "GET_JOURNAL_DAYS_SUCCESS"
export const GET_JOURNAL_DAYS_FAIL = "GET_JOURNAL_DAYS_FAIL"

export const GET_JOURNAL_BY_DAY = "GET_JOURNAL_BY_DAY"
export const GET_JOURNAL_BY_DAY_SUCCESS = "GET_JOURNAL_BY_DAY_SUCCESS"
export const GET_JOURNAL_BY_DAY_FAIL = "GET_JOURNAL_BY_DAY_FAIL"

// Create
export const CREATE_JOURNAL_ENTRY = "CREATE_JOURNAL_ENTRY"
export const CREATE_JOURNAL_ENTRY_SUCCESS = "CREATE_JOURNAL_ENTRY_SUCCESS"
export const CREATE_JOURNAL_ENTRY_FAIL = "CREATE_JOURNAL_ENTRY_FAIL"

// Update
export const UPDATE_JOURNAL_ENTRY = "UPDATE_JOURNAL_ENTRY"
export const UPDATE_JOURNAL_ENTRY_SUCCESS = "UPDATE_JOURNAL_ENTRY_SUCCESS"
export const UPDATE_JOURNAL_ENTRY_FAIL = "UPDATE_JOURNAL_ENTRY_FAIL"

// Delete
export const DELETE_JOURNAL_ENTRY = "DELETE_JOURNAL_ENTRY"
export const DELETE_JOURNAL_ENTRY_SUCCESS = "DELETE_JOURNAL_ENTRY_SUCCESS"
export const DELETE_JOURNAL_ENTRY_FAIL = "DELETE_JOURNAL_ENTRY_FAIL"

// Timeline (all notes across all days)
export const GET_JOURNAL_TIMELINE = "GET_JOURNAL_TIMELINE"
export const GET_JOURNAL_TIMELINE_SUCCESS = "GET_JOURNAL_TIMELINE_SUCCESS"
export const GET_JOURNAL_TIMELINE_FAIL = "GET_JOURNAL_TIMELINE_FAIL"

